import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  reloadFrame ({ target }: { target: HTMLInputElement }): void {
    const frame = this.element.closest('turbo-frame')
    if (frame == null) return

    const form = this.element.closest('form')
    if (form != null) form.inert = true

    const url = new URL(frame.getAttribute('src') ?? '', window.location.href)
    url.searchParams.set('resource_name', target.value)
    frame.setAttribute('src', url.toString())
  }
}
